export default "__VITE_ASSET__CVy4$dvB__"